var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Sheet',{staticClass:"container"},[_c('span',{staticClass:"error hidden-sm-and-down"},[_vm._v("ERROR!")]),_c('span',{staticClass:"error sm hidden-md-and-up"},[_vm._v("ERROR!")]),_c('h1',[_vm._v("500")]),_c('h3',[_vm._v("系統發生錯誤!!")])])}
var staticRenderFns = []

export { render, staticRenderFns }